import axios from 'axios';
import axiosInstance from '../utils/axiosInstance';
import tenantAxiosInstance from '../utils/tenantAxiosInstance';

const API_URL = process.env.REACT_APP_BACKEND_URL;


const CreateAlert = (
  tenant_id,
  body
) => {
  return tenantAxiosInstance
    .post(API_URL + `alert/create/${tenant_id}`, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};
const UpdateAlert = (
  tenant_id,
  alert_id,
  body
) => {
  return tenantAxiosInstance
    .post(API_URL + `alert/update/${tenant_id}/${alert_id}`, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};
const getConfiguredAlerts = (
  tenant_id,
) => {
  return tenantAxiosInstance
    .get(API_URL + `alert/triggered/${tenant_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};


const updatePhoneNumber = (
  tenant_id,
  user_id,
  body
) => {
  return tenantAxiosInstance
    .post(API_URL + `alert/verify_phone/${tenant_id}/${user_id}`,body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};



const resendOtp = (
  tenant_id,
  user_id
) => {
  return tenantAxiosInstance
    .post(API_URL + `alert/resend_otp/${tenant_id}/${user_id}`,{})
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};
const verifyOtp = (
  tenant_id,
  user_id,
  body
) => {
  return tenantAxiosInstance
    .post(API_URL + `alert/verify_otp/${tenant_id}/${user_id}`,body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};

const updateAlertStatus = (
  tenant_id,
  alert_id,
  body
) => {
  return tenantAxiosInstance
    .post(API_URL + `alert/list/${tenant_id}/${alert_id}`,body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};

const deleteAlertStatus = (
  tenant_id,
  alert_id,
  body
) => {
  return tenantAxiosInstance
    .delete(API_URL + `alert/delete/${tenant_id}/${alert_id}`,body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};


const GetAllAlert = (
  tenant_id,
) => {
  return tenantAxiosInstance
    .get(API_URL + `alert/list/${tenant_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error); // Log any request errors
      throw error; // Rethrow the error to handle it in your component
    });
};




const AlertService = {
  CreateAlert,
  getConfiguredAlerts,
  GetAllAlert,
  UpdateAlert,
  deleteAlertStatus,
  updateAlertStatus,
  updatePhoneNumber,
  verifyOtp,
  resendOtp
};

export default AlertService;